"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _antDesignVue = require("ant-design-vue");
var _ResizeableTitle = _interopRequireDefault(require("./ResizeableTitle.vue"));
var _Sort = _interopRequireDefault(require("./Sort.vue"));
var _utils = require("./utils");
var _default = exports.default = {
  name: 'YsTable',
  components: {
    TableSort: _Sort.default,
    ATable: _antDesignVue.Table,
    APagination: _antDesignVue.Pagination
  },
  provide() {
    return {
      columns: () => this.showColumns
    };
  },
  inject: {
    getScrollY: {
      default: undefined
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    // 显示刷新icon
    showReload: {
      type: Boolean,
      default: false
    },
    cacheId: {
      type: [String, undefined],
      default: undefined
    },
    scroll: {
      type: Object,
      default: () => ({
        x: '100%'
      })
    },
    columns: {
      type: Array,
      default: () => []
    },
    /**
     * 溢出后是否省略显示
     * 当为true时会把所有column构建为 { ..., ellipsis: true }
     */
    ellipsis: {
      type: Boolean,
      default: false
    },
    scalable: {
      type: Boolean,
      default: true
    },
    tableProps: {
      type: [Object, undefined],
      default: undefined
    },
    tableEvents: {
      type: [Object, undefined],
      default: undefined
    },
    // 选中的行
    selectedRows: {
      type: Array,
      default: () => []
    },
    // 选中key
    selectedRowKeys: {
      type: Array,
      default: undefined
    },
    // 是否初始化时调用method
    immediate: {
      type: Boolean,
      default: false
    },
    // 获取数据方法
    method: {
      type: [Function, undefined],
      default: undefined
    },
    // 数据
    dataSource: {
      type: [Array, undefined],
      default: undefined
    },
    paginationProps: {
      type: Object,
      default: () => {
        return {
          pageSizeOptions: ['20', '50', '100', '200']
        };
      }
    },
    paginationEvents: {
      type: [Object, undefined],
      default: undefined
    },
    visualPagination: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: [Boolean, Object],
      default: true
    }
  },
  data() {
    return {
      ajaxLoading: false,
      showColumns: [],
      ajaxData: [],
      // 分页器数据
      pageConfig: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      }
    };
  },
  computed: {
    tableScroll() {
      return Object.assign({
        y: this.getScrollY?.()
      }, this.scroll);
    },
    renderColumns() {
      return this.showColumns.filter(column => column.show).map(column => {
        const {
          dataIndex,
          sort
        } = column;
        const sorter = (a, b) => {
          if (typeof a[dataIndex] === 'undefined') return 0;
          if (typeof a[dataIndex] === 'number' || !isNaN(a[dataIndex])) {
            return a[dataIndex] - b[dataIndex];
          }
          return a[dataIndex].localeCompare(b[dataIndex], 'zh-CN');
        };
        return {
          ...column,
          ellipsis: this.ellipsis,
          sorter: (0, _utils.getBoolean)(sort) ? sorter : undefined
        };
      });
    },
    customRenderColumns() {
      return this.getCustomRenderColumns(this.renderColumns);
    },
    tableDataSource() {
      return this.dataSource ?? this.ajaxData;
    },
    components() {
      return !this.scalable ? {} : {
        header: {
          cell: _ResizeableTitle.default
        }
      };
    },
    rowSelection() {
      const selectedRowKeys = this.selectedRowKeys ?? this.selectedRows.map(row => typeof this.tableProps.rowKey === 'function' ? this.tableProps.rowKey(row) : row[this.tableProps.rowKey]);
      return this.tableProps?.rowSelection ? {
        columnWidth: 50,
        fixed: false,
        ...this.tableProps.rowSelection,
        selectedRowKeys: selectedRowKeys,
        onChange: this.onSelectChange
      } : undefined;
    },
    visualPaginationProps() {
      if (!this.visualPagination) {
        return false;
      }
      return {
        pageSizeOptions: this.paginationProps.pageSizeOptions,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共${total}条`
      };
    }
  },
  watch: {
    columns: {
      handler(columns) {
        this.showColumns = columns.filter(column => (0, _utils.getBoolean)(column.visible)).map(column => ({
          ...column,
          show: true
        }));
        this.$nextTick(() => {
          this.cacheId && this.$refs.tableSort.init();
        });
      },
      immediate: true
    },
    pagination: {
      handler(value) {
        if (typeof this.pagination === 'boolean') {
          return;
        }
        Object.assign(this.pageConfig, value);
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    if (this.immediate) {
      this.reload();
    }
  },
  methods: {
    reload(pageNo = undefined) {
      this.pageConfig.pageNo = pageNo ? pageNo : 1;
      this.$emit('update:selected-rows', []);
      this.$emit('update:selected-row-keys', []);
      return this.getData();
    },
    reloadCurrentPage() {
      this.reload(this.pageConfig.pageNo);
    },
    onSelectChange(selectedRowKeys) {
      const rowKey = this.tableProps.rowKey;
      const rows = this.tableDataSource.filter(record => {
        const key = typeof rowKey === 'function' ? rowKey(record) : record[rowKey];
        return selectedRowKeys.includes(key);
      });
      this.$emit('update:selected-rows', rows);
      this.$emit('update:selected-row-keys', selectedRowKeys);
    },
    handlePageChange(pageNo, pageSize) {
      this.pageConfig = {
        ...this.pageConfig,
        pageNo,
        pageSize
      };
      if (!this.isPaginationBoolean) {
        this.$emit('update:pagination', {
          pageNo,
          pageSize
        });
      }
      this.$emit('page-change', {
        pageNo,
        pageSize
      });
      this.reload(pageNo);
    },
    handlePageSizeChange(pageNo, pageSize) {
      this.handlePageChange(1, pageSize);
    },
    async getData() {
      if (!this.method) {
        return;
      }
      try {
        this.ajaxLoading = true;
        const {
          pageNo,
          pageSize
        } = this.pageConfig;
        const res = await this.method({
          pageNo,
          pageSize
        });
        this.pageConfig.total = res.total;
        this.ajaxData = res.records;
        return this.ajaxData;
      } finally {
        this.ajaxLoading = false;
      }
    },
    getCustomRenderColumns(columns) {
      const res = [];
      columns.forEach(column => {
        if (column.scopedSlots?.customRender) {
          res.push(column);
        }
        if (column.children?.length) {
          res.push(...this.getCustomRenderColumns(column.children));
        }
      });
      return res;
    }
  }
};